import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface DashboardSectionProps {
  title: string;
  children: React.ReactNode;
  description?: string;
  action?: React.ReactNode;
  className?: string;
}

const DashboardSection: React.FC<DashboardSectionProps> = ({
  title,
  children,
  description,
  action,
  className = ''
}) => {
  return (
    <Card className={`shadow-sm ${className}`}>
      <CardHeader className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 px-4 sm:px-6">
        <div>
          <CardTitle className="text-lg sm:text-xl font-semibold">{title}</CardTitle>
          {description && (
            <p className="text-xs sm:text-sm text-muted-foreground mt-1">{description}</p>
          )}
        </div>
        {action && (
          <div className="w-full sm:w-auto flex justify-end">
            {action}
          </div>
        )}
      </CardHeader>
      <CardContent className="px-4 sm:px-6 overflow-x-auto">
        <div className="min-w-[400px] sm:min-w-0">
          {children}
        </div>
      </CardContent>
    </Card>
  );
};

export default DashboardSection; 